import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {inject} from 'mobx-react';
import {action} from 'mobx';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';

import ProgressiveBackgroundImage from 'spa/Components/ProgressiveBackgroundImage';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import 'spa/styles/home.less';
import '../../Home/HomeOverviewSection.less';

@inject(({store: {screen, tracker}}) => ({
  screen,
  tracker,
}))
@withI18n
class HomeOverviewSectionForDigital extends React.Component {
  static propTypes = {
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @autobind
  @action('onClickBook - HomeOverviewSectionForDigital')
  onClickBook() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'Book Now',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked Book Now button', trackingData);
  }

  render() {
    const {i18n} = this.context;
    const {screen: {isDesktop}} = this.props;

    return (
      <div className="home-overview-section home-content-section row">
        <div className="home-content-section__cell home-content-section__cell-text home-content-section-for-digital__cell-text home-content-section--pull-bottom">
          <div className="home-content-section__text-content">
            <h2 className="home-content-section__title home-content-section-for-digital__title">{i18n._x('How it works', 'Home overview section title')}</h2>

            <ul className="home-content-section__list">
              <li className="home-content-section__list-item">
                <h4 className="home-content-section__list-title home-content-section-for-digital__list-title">{i18n._x('50+ ways to feel well', 'Home overview section list title')}</h4>
                <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">{i18n._x('From massage and beauty treatments to yoga, fitness, physio and mindfulness.', 'Home overview section description')}</p>
              </li>
              <li className="home-content-section__list-item">
                <h4 className="home-content-section__list-title home-content-section-for-digital__list-title">{i18n._x('Pick your trusted pro', 'Home overview section list title')}</h4>
                <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">{i18n._x('Detailed profiles display ratings and reviews to help you choose.', 'Home overview section description')}</p>
              </li>
              <li className="home-content-section__list-item">
                <h4 className="home-content-section__list-title home-content-section-for-digital__list-title">{i18n._x('We\'ll come to you', 'Home overview section list title')}</h4>
                <p className="home-content-section__list-paragraph home-content-section-for-digital__list-paragraph">{i18n._x('Online or in-person, at home or in the office, from 7am-11pm daily.', 'Home overview section description')}</p>
              </li>
            </ul>
            <Link
              className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
              data-qa="home-services-section-digital-button"
              onClick={this.onClickBook}
              to={`/${i18n.lc}/booking/`}
            >
              {i18n._x('Book at home or online', 'Homepage book now button')}
            </Link>
          </div>
        </div>
        <ProgressiveBackgroundImage
          customClass="home-content-section__cell home-content-section__cell-image home-content-section-for-digital__cell-image home-overview-section__cell-image"
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585840688/b2c-art/home-2020/digital/img_homepage_tailored_1x.jpg"
          highResImg=""
          highResImg2x=""
          mediaQueries={[
            {
              query: '(max-width: 768px)',
              highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840694/b2c-art/home-2020/digital/img_homepage_tailored_2x.jpg',
              highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840695/b2c-art/home-2020/digital/img_homepage_tailored_3x.jpg',
            },
          ]}
        >
          {isDesktop && (
            <ProgressiveImage
              className="home-overview-section__cell-image-element"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1585840688/b2c-art/home-2020/digital/img_homepage_tailored_1x.jpg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840694/b2c-art/home-2020/digital/img_homepage_tailored_2x.jpg"
              highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto/v1585840695/b2c-art/home-2020/digital/img_homepage_tailored_3x.jpg"
            />
          )}
        </ProgressiveBackgroundImage>
      </div>
    );
  }
}

export default HomeOverviewSectionForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeOverviewSectionForDigital.jsx